export default (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M21.4242 5.36105C21.872 5.82833 21.8562 6.57015 21.389 7.01796L9.97591 17.9555C9.52263 18.3898 8.80754 18.3898 8.35426 17.9555L3.36105 13.1703C2.89377 12.7225 2.87799 11.9807 3.3258 11.5134C3.7736 11.0461 4.51543 11.0303 4.9827 11.4781L9.16508 15.4863L19.7673 5.3258C20.2346 4.87799 20.9764 4.89377 21.4242 5.36105Z"
    fill="currentColor"
  />
);
